<div class="content-wrapper">
	<activity-task-overview></activity-task-overview>
	<activity-task-pane (taskSelected)="onTaskSelected($event)" [viewOnly]="true"></activity-task-pane>
</div>
